import { EProductType } from '@common/enums/product-type.enum';
import { consoleService } from '@common/services/console.service';
import { isDeliverySurchargeAddon } from '@common/utils/is-delivery-surcharge-addon/is-delivery-surcharge-addon.util';
import { IProductCatalogItemDto } from './product-catalog-item.dto';

export interface IExtendedProductCatalogItemDto extends Omit<IProductCatalogItemDto, 'price'> {
    item_price_id: string;
    name: string;
    cf_imageurl: string;
    amount: number;
    quantity: number;
    cf_is_excluded_from_global_limit: boolean;
}

export const createExtendProductCatalogItemDto = ({
    amount,
    item_price_id,
    quantity,
    product,
}: {
    item_price_id: string | undefined;
    amount: number | undefined;
    quantity: number | undefined;
    product: Omit<IProductCatalogItemDto, 'price'> | undefined;
}): IExtendedProductCatalogItemDto => {
    consoleService.assert(item_price_id, 'item_price_id can not be empty ');

    const res = {
        ...((product || { item: { prices: [] } }) as IProductCatalogItemDto),
        item_price_id: item_price_id || '',
        name: product?.item?.name || '',
        cf_imageurl: product?.item?.image_url || '',
        amount: amount || 0,
        quantity: quantity || 0,
        cf_is_excluded_from_global_limit: product?.item?.is_excluded_from_global_limit || false,
    };
    if (res?.item?.type === EProductType.feeAddon) {
        return {
            ...res,
            name: 'Subscription Box',
            item: {
                ...res.item,
                name: 'Subscription Box',
            },
        };
    }
    if (isDeliverySurchargeAddon(item_price_id)) {
        return {
            ...res,
            name: 'The Odd Shop',
            item: {
                ...(res.item || {
                    prices: [],
                }),
                name: 'The Odd Shop',
            },
        };
    }
    return res;
};
